import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image.png'
import _imports_1 from '../../assets/image1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3dc31d46")

_pushScopeId("data-v-3dc31d46")
const _hoisted_1 = { style: {"flex":"1"} }
const _hoisted_2 = { style: {"box-sizing":"border-box","color":"black","padding":"20px 0"} }
const _hoisted_3 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_4 = {
  class: "collapse-content",
  style: {"padding":"20px"},
  key: "content"
}
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_7 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { style: {"border-bottom":"2px solid #c1c1c1","flex-grow":"1"} }, null, -1)
const _hoisted_11 = { style: {"width":"32px","height":"32px"} }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { style: {"border-bottom":"2px solid #c1c1c1","flex-grow":"1"} }, null, -1)
const _hoisted_13 = { style: {"padding":"30px 30px","background":"#d1edff"} }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "report_scroll",
    class: "TitleStyle"
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("测试信息 ")
  ])
], -1)
const _hoisted_15 = { style: {"display":"flex"} }
const _hoisted_16 = { class: "no-bullet" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "测试场景:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "测试时间:", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "测试时长:", -1)
const _hoisted_20 = {
  class: "no-bullet",
  style: {"margin":"0 200px"}
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "机型:", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "芯片:", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, "GPU:", -1)
const _hoisted_24 = { class: "no-bullet" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "当前版本:", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "对比版本:", -1)
const _hoisted_27 = { class: "testMain" }
const _hoisted_28 = { class: "module_djalog" }
const _hoisted_29 = { class: "dialog-content configurationStyle" }
const _hoisted_30 = { class: "form-items" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_32 = { class: "check_style" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("变差就有风险")
const _hoisted_34 = { class: "check_style" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 2,
  style: {"margin":"0 10px"}
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("启用基线")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("启用变化阈值")
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "module_djalog" }
const _hoisted_47 = { class: "dialog-content" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("只显示模块")
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { style: {"display":"flex"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("添加一行")
const _hoisted_56 = {
  style: {"display":"flex","justify-content":"flex-start"},
  class: "add_input"
}
const _hoisted_57 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_58 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_59 = /*#__PURE__*/_createVNode("span", null, "提交", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("span", null, "取消修改", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "report_scroll",
    class: "TitleStyle"
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("CPU性能 ")
  ])
], -1)
const _hoisted_62 = { class: "gameTable_cpu" }
const _hoisted_63 = { style: {"font-weight":"bold"} }
const _hoisted_64 = /*#__PURE__*/_createVNode("td", null, "测试场景", -1)
const _hoisted_65 = { style: {"text-align":"right"} }
const _hoisted_66 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 局内趋势 ")
], -1)
const _hoisted_67 = {
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_68 = /*#__PURE__*/_createVNode("div", {
  style: {"height":"450px"},
  id: "cpu_side"
}, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 迭代趋势 ")
], -1)
const _hoisted_70 = {
  style: 'height:' + 300 + 'px',
  id: "cpu"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_Transition, { name: "collapse" }, {
                  default: _withId(() => [
                    _withDirectives(_createVNode("div", _hoisted_4, [
                      _createVNode(_component_el_form, {
                        class: "anaysis_class",
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_5, [
                            _createVNode(_component_el_form_item, { label: "是否自动" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.auto_query,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.auto_query = $event)),
                                  placeholder: "请选择",
                                  multiple: "",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (
                          _ctx.versionChange(false, ['type', 'scene', 'device'])
                        )),
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.label,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "父类型"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      filterable: "",
                                      onChange: _cache[3] || (_cache[3] = ($event: any) => (
                          _ctx.versionChange(
                            false,
                            ['type', 'scene', 'device'],
                            (_ctx.subtype_query = '')
                          )
                        )),
                                      modelValue: _ctx.type_query,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.type_query = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_data, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: "子类型"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[5] || (_cache[5] = ($event: any) => (
                          _ctx.versionChange(false, ['type', 'scene', 'device'])
                        )),
                                      key: _ctx.sub_key,
                                      filterable: "",
                                      modelValue: _ctx.subtype_query,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.subtype_query = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_data, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini",
                                  style: {"margin-left":"20px"},
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.configurationShow = true))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini",
                        class: "anaysis_class"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_7, [
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "场景"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.scene,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataConsumeOptions.scene = $event)),
                                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.versionChange(false, ['scene', 'device']))),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.scene_id,
                                        label: item.scene__chinese,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "机型"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.device,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dataConsumeOptions.device = $event)),
                                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.versionChange(false, ['device']))),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.device_id,
                                        label: 
                            item.device__level +
                            '档机-' +
                            item.device__model__name +
                            '-' +
                            item.device__model__model +
                            '-' +
                            item.device__UUID
                          ,
                                        value: item.device_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "版本"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.version,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataConsumeOptions.version = $event)),
                                  placeholder: "请选择",
                                  onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.versionChange(true))),
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.chinese,
                                        value: item.chinese
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "对比版本"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.old_verson,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dataConsumeOptions.old_verson = $event)),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOldOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.chinese,
                                        value: item.chinese
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.confirm,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, _ctx.serchDataShow]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, [
                    (!_ctx.serchDataShow)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          style: {"width":"100%","height":"100%"},
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openBtn && _ctx.openBtn(...args))),
                          src: _imports_0,
                          alt: ""
                        }))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          style: {"width":"100%","height":"100%"},
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.openBtn && _ctx.openBtn(...args))),
                          src: _imports_1,
                          alt: ""
                        }))
                  ]),
                  _hoisted_12
                ]),
                _withDirectives(_createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _createVNode("ul", _hoisted_16, [
                      _createVNode("li", null, [
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.scene), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_18,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.tiemline), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_19,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.duration), 1)
                      ])
                    ]),
                    _createVNode("ul", _hoisted_20, [
                      _createVNode("li", null, [
                        _hoisted_21,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.device_level +
                      "-" +
                      _ctx.report_data_list?.device_name), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_22,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.cpu_name), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_23,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.gpu_name), 1)
                      ])
                    ]),
                    _createVNode("ul", _hoisted_24, [
                      _createVNode("li", null, [
                        _hoisted_25,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.version), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_26,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.old_version), 1)
                      ])
                    ])
                  ])
                ], 512), [
                  [_directive_loading, _ctx.report_text_show]
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.configurationShow,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.configurationShow = $event)),
                      width: "70%",
                      class: "custom-dialog",
                      height: "auto"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_30, [
                                _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.configChange,
                                      modelValue: _ctx.configuration_form.scene_id,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.configuration_form.scene_id = $event)),
                                      placeholder: "请选择",
                                      filterable: ""
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_old_table, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.scene__chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "选择平台" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.configChange,
                                      modelValue: _ctx.configuration_form.moudle,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.configuration_form.moudle = $event)),
                                      placeholder: "选择平台",
                                      filterable: ""
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_el_form_item, { class: "save-button" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.save_button
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_31
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_32, [
                            _createVNode(_component_el_checkbox, {
                              onChange: _cache[19] || (_cache[19] = ($event: any) => (
                          _ctx.is_bad_risk == true
                            ? (_ctx.threshold_check = false)
                            : (_ctx.threshold_check = _ctx.threshold_check)
                        )),
                              modelValue: _ctx.is_bad_risk,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.is_bad_risk = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_34, [
                            (!_ctx.baseline_check)
                              ? (_openBlock(), _createBlock("span", _hoisted_35, "添加基线列"))
                              : (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  style: {"color":"#409eff","cursor":"pointer"},
                                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addRow_baseline()))
                                }, "添加基线列")),
                            (!_ctx.threshold_check)
                              ? (_openBlock(), _createBlock("span", _hoisted_36, "添加变化阈值列"))
                              : (_openBlock(), _createBlock("span", {
                                  key: 3,
                                  style: {"margin":"0 10px","color":"#409eff","cursor":"pointer"},
                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addRow_threshold()))
                                }, "添加变化阈值列")),
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.baseline_check,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.baseline_check = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_37
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_checkbox, {
                              disabled: _ctx.is_bad_risk,
                              modelValue: _ctx.threshold_check,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.threshold_check = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_38
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _createVNode(_component_el_table, {
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                            "cell-style": _ctx.cellStyle2,
                            data: _ctx.configuration_table_data
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                width: "120",
                                label: "指标"
                              }, {
                                default: _withId((scope) => [
                                  (
                              scope.$index == 5 &&
                              (_ctx.baseline_check || _ctx.threshold_check)
                            )
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: scope.row.name,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.name = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(scope.row.name), 1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "基线" }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_baseline, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      width: "150",
                                      key: index
                                    }, {
                                      header: _withId(() => [
                                        (!_ctx.baseline_check)
                                          ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                return (_openBlock(), _createBlock("span", {
                                                  style: 
                                  'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                  _ctx.gear_position.filter((c) => c.value == i)[0]
                                    .background
                                ,
                                                  key: i
                                                }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                    .name), 5))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              size: "mini",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                  _ctx.configuration_table_baseline,
                                  _ctx.gear_position_all,
                                  index
                                ), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.name,
                                                    value: item.value,
                                                    disabled: item.disabled
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      default: _withId((scope) => [
                                        (!_ctx.baseline_check && scope.row.name != '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(scope.row.baseline[index]), 1))
                                          : (
                                !_ctx.baseline_check && scope.row.name === ''
                              )
                                            ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(scope.row.baseline[index]), 1))
                                            : (_ctx.baseline_check && scope.row.name != '')
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: scope.row.baseline[index],
                                                  "onUpdate:modelValue": ($event: any) => (scope.row.baseline[index] = $event)
                                                }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.baseline[index]), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              : (_ctx.baseline_check && scope.row.name == '')
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 3,
                                                    style: {"color":"#409eff","cursor":"pointer"},
                                                    onClick: ($event: any) => (_ctx.delete_baseline(index))
                                                  }, _toDisplayString(scope.row.baseline[index]), 9, ["onClick"]))
                                                : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "变化阈值" }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_threshold, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      width: "150",
                                      key: index
                                    }, {
                                      header: _withId(() => [
                                        (!_ctx.threshold_check)
                                          ? (_openBlock(), _createBlock("div", _hoisted_43, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                return (_openBlock(), _createBlock("span", {
                                                  style: 
                                  'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                  _ctx.gear_position.filter((c) => c.value == i)[0]
                                    .background
                                ,
                                                  key: i
                                                }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                    .name), 5))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              size: "mini",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                  _ctx.configuration_table_threshold,
                                  _ctx.gear_position_all_threshold,
                                  index
                                ), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.name,
                                                    value: item.value,
                                                    disabled: item.disabled
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      default: _withId((scope) => [
                                        (!_ctx.threshold_check && scope.row.name != '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(scope.row.threshold[index]), 1))
                                          : (
                                !_ctx.threshold_check && scope.row.name == ''
                              )
                                            ? (_openBlock(), _createBlock("span", _hoisted_45, _toDisplayString(scope.row.threshold[index]), 1))
                                            : (
                                _ctx.threshold_check && scope.row.name != ''
                              )
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: scope.row.threshold[index],
                                                  "onUpdate:modelValue": ($event: any) => (scope.row.threshold[index] = $event)
                                                }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.threshold[index]), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              : (
                                _ctx.threshold_check && scope.row.name == ''
                              )
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 3,
                                                    onClick: ($event: any) => (_ctx.delete_threshold(index)),
                                                    style: {"color":"#409eff","cursor":"pointer"}
                                                  }, _toDisplayString(scope.row.threshold[index]), 9, ["onClick"]))
                                                : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["cell-style", "data"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_46, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.tableAddShow,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.tableAddShow = $event)),
                      width: "80%",
                      class: "custom-dialog",
                      height: "auto"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_47, [
                          _createVNode(_component_el_checkbox, {
                            modelValue: _ctx.conFig.is_show_function_check,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.conFig.is_show_function_check = $event))
                          }, {
                            default: _withId(() => [
                              _hoisted_48
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_table, {
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                            data: _ctx.conFig.module_list
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, { label: "线程" }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(scope.row.thread), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.thread,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.thread = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              (_ctx.localProject != 7)
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    label: "so"
                                  }, {
                                    default: _withId((scope) => [
                                      (!scope.row.edit)
                                        ? (_openBlock(), _createBlock("span", _hoisted_50, _toDisplayString(scope.row.so), 1))
                                        : (_openBlock(), _createBlock(_component_el_input, {
                                            key: 1,
                                            modelValue: scope.row.so,
                                            "onUpdate:modelValue": ($event: any) => (scope.row.so = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_table_column, { label: "模块/函数名" }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_51, _toDisplayString(scope.row.module), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.module,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.module = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "是否函数",
                                width: "80"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_checkbox, {
                                    disabled: !scope.row.edit,
                                    modelValue: scope.row.func_check,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.func_check = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "父模块" }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("span", _hoisted_52, _toDisplayString(scope.row.parent), 1))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: scope.row.parent,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.parent = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "函数列表",
                                width: "400"
                              }, {
                                default: _withId((scope) => [
                                  (!scope.row.edit)
                                    ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.functions, (item) => {
                                          return (_openBlock(), _createBlock("div", { key: item }, _toDisplayString(item), 1))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        rows: "10",
                                        type: "textarea",
                                        modelValue: scope.row.functions_string,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.functions_string = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "趋势图",
                                width: "80"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_checkbox, {
                                    disabled: !scope.row.edit,
                                    modelValue: scope.row.trend_check,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.trend_check = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "表格",
                                width: "80"
                              }, {
                                default: _withId((scope) => [
                                  _createVNode(_component_el_checkbox, {
                                    disabled: !scope.row.edit,
                                    modelValue: scope.row.show_check,
                                    "onUpdate:modelValue": ($event: any) => (scope.row.show_check = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "操作" }, {
                                default: _withId((scope) => [
                                  _createVNode("div", _hoisted_54, [
                                    _createVNode(_component_el_button, {
                                      type: "primary",
                                      size: "mini",
                                      onClick: ($event: any) => (_ctx.edit1(scope.row))
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.edit ? "确认" : "修改"), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      size: "mini",
                                      onClick: ($event: any) => (_ctx.clear(scope.row, scope.$index))
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.edit ? "取消" : "删除"), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"]),
                          (!_ctx.addShow)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                size: "mini",
                                style: {"margin-top":"10px"},
                                type: "primary",
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.addRow()))
                              }, {
                                default: _withId(() => [
                                  _hoisted_55
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.addShow)
                            ? (_openBlock(), _createBlock(_component_el_form, {
                                key: 1,
                                style: {"margin":"10px 0"},
                                size: "mini",
                                "label-position": "top"
                              }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_56, [
                                    _createVNode(_component_el_form_item, {
                                      label: "线程",
                                      style: {"margin-right":"25px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.add_row_data.so = '')),
                                          modelValue: _ctx.add_row_data.thread,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.add_row_data.thread = $event)),
                                          id: "old_version",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thread_add, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "so",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.add_row_data.so,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.add_row_data.so = $event)),
                                          id: "old_version",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.so_list[_ctx.add_row_data.thread], (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "模块/函数名",
                                      style: {"margin-right":"45px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.add_row_data.moudel,
                                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.add_row_data.moudel = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "是否函数",
                                      width: "50",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.add_row_data.func_check,
                                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.add_row_data.func_check = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "父模块",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.add_row_data.parent,
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.add_row_data.parent = $event)),
                                          id: "old_version",
                                          placeholder: "请选择"
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.parentList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "函数名",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          type: "textarea",
                                          rows: "1",
                                          modelValue: _ctx.add_row_data.functions_string,
                                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.add_row_data.functions_string = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "趋势图",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.add_row_data.trend_check,
                                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.add_row_data.trend_check = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "表格",
                                      style: {"margin-right":"35px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.add_row_data.show_check,
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.add_row_data.show_check = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "按钮" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          size: "mini",
                                          type: "primary",
                                          onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.addList()))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_57
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_58, [
                            _createVNode(_component_el_popconfirm, {
                              title: "确认提交？",
                              onConfirm: _cache[38] || (_cache[38] = ($event: any) => (_ctx.submit_edit())),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_59
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认是否放弃本次修改？",
                              onConfirm: _cache[39] || (_cache[39] = ($event: any) => (_ctx.submit_cancellation())),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "info",
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_60
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", null, [
                    _hoisted_61,
                    _withDirectives(_createVNode("table", _hoisted_62, [
                      _createVNode("thead", _hoisted_63, [
                        _createVNode("tr", null, [
                          _hoisted_64,
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params_cpu, (item) => {
                            return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                          }), 128))
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.expand
                        ? _ctx.cpu_usage_data?.filter((v, index) => index == 0)
                        : _ctx.cpu_usage_data, (v) => {
                          return (_openBlock(), _createBlock("tr", { key: v }, [
                            _createVNode("td", null, _toDisplayString(v.label), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.params_cpu, (item) => {
                              return (_openBlock(), _createBlock("td", { key: item }, [
                                _createVNode("span", {
                                  style: 
                            'color:' +
                            _ctx.com_color(item.value, v.new[item.value])[0]
                          
                                }, _toDisplayString(v.new[item.value]), 5),
                                _createVNode("span", {
                                  style: 
                            'color:' +
                            _ctx.com_color(
                              item.value,
                              v.new[item.value],
                              v.old[item.value]
                            )[1]
                          
                                }, "(" + _toDisplayString(_ctx.getNum(v.new[item.value], v.old[item.value])) + ")", 5)
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ], 512), [
                      [_directive_loading, _ctx.cpu_loading]
                    ]),
                    _createVNode("div", _hoisted_65, [
                      _createVNode("span", {
                        style: {"color":"#5cb6ff","cursor":"pointer"},
                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.expand = !_ctx.expand))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.expand ? "展开子场景" : "关闭子场景"), 1),
                        _createVNode("i", {
                          class: 
                        _ctx.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
                      
                        }, null, 2)
                      ])
                    ]),
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          class: "version_input",
                          label: "选择CPU核心"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.cpu_index,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.cpu_index = $event)),
                              onChange: _ctx.cpuChange,
                              placeholder: "Select"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_trend_index, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode("div", null, [
                      _hoisted_66,
                      _withDirectives(_createVNode(_component_el_card, {
                        style: {"position":"relative","width":"100%"},
                        class: "spacName"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_67, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpuThread_list, (item, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                style: {
                          background: item.color,
                          width: item.width,
                        }
                              }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                            }), 128))
                          ]),
                          _hoisted_68
                        ]),
                        _: 1
                      }, 512), [
                        [_directive_loading, _ctx.gpu_loading]
                      ])
                    ]),
                    _createVNode("div", null, [
                      _hoisted_69,
                      _createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          _withDirectives(_createVNode("div", _hoisted_70, null, 512), [
                            [_directive_loading, _ctx.moudle_loading]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})